import React, { useEffect, useState, useRef } from "react";
import {
  Grid,
  Card,
  Button,
  TextField,
  Box,
  InputLabel,
  FormControl,
  MenuItem,
  Select,
} from "@mui/material";
import { useFormik } from "formik";
import { getCdrRequest, getPhoneNumberRequest, getCampaignNameRequest } from "../../../api/api";
import MDTypography from "components/MDTypography";
import DataTable from "examples/Tables/DataTable";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import CustomPagination from "../../../pagination/CustomPagination";
import Loader from "../../../Loader/loader";
function ReportTable() {
  const [phoneOptions, setPhoneOptions] = useState([]);
  const [campaignOptions, setCampaignOptions] = useState([]);
  const [rows, setRows] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [totalCount, setTotalCount] = useState(0);
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(100);

  const formik = useFormik({
    initialValues: {
      phone_number: "",
      call_answer_status: "",
      campaign_name: "",
      from_date: "",
      to_date: "",
    },
    onSubmit: () => {
      setPage(1);
      fetchData();
    },
  });

  const columns = [
    // { Header: "Date", accessor: "created_at", align: "center" },
    { Header: "Call Date", accessor: "call_date", align: "center" },
    { Header: "Lead ID", accessor: "id", align: "left" },

    { Header: "Camp.caller ID", accessor: "caller_number", align: "left" },
    { Header: "Campaign Name", accessor: "campaign_name", align: "center" },
    { Header: "Destination", accessor: "destination", align: "center" },

    { Header: "Codec", accessor: "codec", align: "center" },
    { Header: "Customer", accessor: "customer_number", align: "center" },
    { Header: "Disposition A", accessor: "disposition_A", align: "center" },
    { Header: "Disposition B", accessor: "disposition_B", align: "center" },
    { Header: "Reason", accessor: "reason", align: "center" },
    { Header: "Duration", accessor: "total_duration", align: "center" },
    { Header: "Trunk IP", accessor: "trunk_ip", align: "center" },
    { Header: "Trunk Name", accessor: "trunk_name", align: "center" },
    { Header: "DTMF Value", accessor: "dtmf_value", align: "center" },
  ];

  const fetchData = async () => {
    setIsLoading(true);
    try {
      const cleanFilters = Object.fromEntries(
        Object.entries(formik.values).filter(([_, v]) => v !== "")
      );

      const res = await getCdrRequest(page, rowsPerPage, cleanFilters);

      const response = res?.data || {};
      const cdrData = response.data || [];
      const formattedRows = cdrData.map((item) => ({
        call_date: (
          <MDTypography variant="button" fontWeight="medium">
            {item.call_date || "N/A"}
          </MDTypography>
        ),
        id: (
          <MDTypography variant="button" fontWeight="medium">
            {item.id}
          </MDTypography>
        ),

        caller_number: (
          <MDTypography variant="button" fontWeight="medium">
            {item.caller_number || "N/A"}
          </MDTypography>
        ),

        campaign_name: (
          <MDTypography variant="button" fontWeight="medium">
            {item.campaign_name || "N/A"}
          </MDTypography>
        ),

        destination: (
          <MDTypography variant="button" fontWeight="medium">
            {item.destination || "N/A"}
          </MDTypography>
        ),

        codec: (
          <MDTypography variant="button" fontWeight="medium">
            {item.codec || "N/A"}
          </MDTypography>
        ),

        customer_number: (
          <MDTypography variant="button" fontWeight="medium">
            {item.customer_number || "N/A"}
          </MDTypography>
        ),

        disposition_A: (
          <MDTypography variant="button" fontWeight="medium">
            {item.disposition_A || "N/A"}
          </MDTypography>
        ),

        disposition_B: (
          <MDTypography variant="button" fontWeight="medium">
            {item.disposition_B || "N/A"}
          </MDTypography>
        ),

        reason: (
          <MDTypography variant="button" fontWeight="medium">
            {item.reason || "N/A"}
          </MDTypography>
        ),

        total_duration: (
          <MDTypography variant="button" fontWeight="medium">
            {item.total_duration ?? "N/A"}
          </MDTypography>
        ),

        trunk_ip: (
          <MDTypography variant="button" fontWeight="medium">
            {item.trunk_ip || "N/A"}
          </MDTypography>
        ),

        trunk_name: (
          <MDTypography variant="button" fontWeight="medium">
            {item.trunk_name || "N/A"}
          </MDTypography>
        ),

        dtmf_value: (
          <MDTypography variant="button" fontWeight="medium">
            {item.dtmf_value ?? "N/A"}
          </MDTypography>
        ),

        created_at: (
          <MDTypography variant="button" fontWeight="medium">
            {item.created_at || "N/A"}
          </MDTypography>
        ),
      }));

      setRows(formattedRows);
      setTotalCount(response.total ?? cdrData.length);
    } catch (error) {
      console.error("CDR fetch error:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleDownload = async () => {
    try {
      // Remove empty filters
      const cleanFilters = Object.fromEntries(
        Object.entries(formik.values).filter(([_, v]) => v !== "")
      );

      // Fetch filtered or all data
      const res = await getCdrRequest(1, 100000, cleanFilters);
      const data = res?.data?.data?.data || [];

      if (data.length === 0) {
        alert("No records to download.");
        return;
      }

      // Define columns to download
      const headers = [
        // { label: "Date", key: "created_at" },
        { label: "Phone Number", key: "phone_number" },
        { label: "Campaign Name", key: "campaign_name" },
        { label: "Call Status", key: "call_answer_status" },
        { label: "DTMF", key: "dtmf_capture" },
        { label: "Destination", key: "transfer_destination" },
      ];

      const csvRows = [];

      // Header row
      csvRows.push(headers.map((h) => h.label).join(","));

      // Data rows with fallback to "N/A"
      for (const row of data) {
        const csvRow = headers.map((h) => {
          let val = row[h.key];
          if (val === undefined || val === null || val === "") {
            val = "N/A";
          }
          return `"${val.toString().replace(/"/g, '""')}"`; // escape quotes
        });
        csvRows.push(csvRow.join(","));
      }

      // Create and trigger CSV download
      const blob = new Blob([csvRows.join("\n")], { type: "text/csv" });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = "cdr_report.csv";
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (error) {
      console.error("Download failed:", error);
      alert("Failed to download data.");
    }
  };

  useEffect(() => {
    fetchData();
  }, [page, rowsPerPage]);

  useEffect(() => {
    const fetchPhoneNumbers = async () => {
      try {
        const res = await getPhoneNumberRequest();
        const numbers = res?.data?.data || [];
        setPhoneOptions(numbers);
      } catch (error) {
        console.error("Failed to fetch phone numbers:", error);
      }
    };
    fetchPhoneNumbers();
  }, []);

  useEffect(() => {
    const fetchCampaignName = async () => {
      try {
        const res = await getCampaignNameRequest();
        const campaignData = res?.data?.data || [];
        setCampaignOptions(campaignData);
      } catch (error) {
        console.error("Failed to fetch Campaigns:", error);
      }
    };
    fetchCampaignName();
  }, []);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Grid container spacing={3}>
        <Grid container spacing={2} alignItems="center" sx={{ p: 2 }}>
          <Grid item xs={12} sm={6} md={2}>
            <TextField
              fullWidth
              type="date"
              label="From Date"
              name="from_date"
              value={formik.values.from_date}
              onChange={formik.handleChange}
              size="small"
              InputLabelProps={{ shrink: true }}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={2}>
            <TextField
              fullWidth
              type="date"
              label="To Date"
              name="to_date"
              value={formik.values.to_date}
              onChange={formik.handleChange}
              size="small"
              InputLabelProps={{ shrink: true }}
            />
          </Grid>
          <Grid item xs={12} sm={6} md={2}>
            <FormControl fullWidth size="small">
              <InputLabel id="phone_number-label">Phone Number</InputLabel>
              <Select
                labelId="phone_number-label"
                id="phone_number"
                name="phone_number"
                value={formik.values.phone_number}
                onChange={formik.handleChange}
                label="Phone Number"
                sx={{ height: 40 }}
              >
                <MenuItem value="">
                  <em>Select</em>
                </MenuItem>
                {phoneOptions.map((item, index) => (
                  <MenuItem key={index} value={item.phone_number}>
                    {item.phone_number}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={6} md={2}>
            <FormControl fullWidth size="small">
              <InputLabel id="call_answer_status-label">Call Status</InputLabel>
              <Select
                labelId="call_answer_status-label"
                id="call_answer_status"
                name="call_answer_status"
                value={formik.values.call_answer_status}
                onChange={formik.handleChange}
                label="Call Status"
                sx={{ height: 40 }}
              >
                <MenuItem value="">
                  <em>Select</em>
                </MenuItem>
                <MenuItem value="answered">Answered</MenuItem>
                <MenuItem value="dropped">Dropped</MenuItem>
                <MenuItem value="dialed">Dialed</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} sm={6} md={2}>
            <FormControl fullWidth size="small">
              <InputLabel id="campaign_name-label">Campaign Name</InputLabel>
              <Select
                labelId="campaign_name-label"
                id="campaign_name"
                name="campaign_name"
                value={formik.values.campaign_name}
                onChange={formik.handleChange}
                label="Campaign Name"
                sx={{ height: 40 }}
              >
                <MenuItem value="">
                  <em>Select</em>
                </MenuItem>
                {campaignOptions.map((item) => (
                  <MenuItem key={item.id} value={item.campaign_name}>
                    {item.campaign_name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={12} sm={6} md={1}>
            <Button
              fullWidth
              variant="outlined"
              onClick={formik.handleSubmit}
              sx={{
                height: "40px",
                backgroundColor: "green",
                color: "white",
                fontWeight: "bold",
                "&:hover": { backgroundColor: "green" },
              }}
            >
              Submit
            </Button>
          </Grid>

          <Grid item xs={12} sm={6} md={1}>
            <Button
              fullWidth
              variant="outlined"
              onClick={handleDownload}
              sx={{
                height: "40px",
                backgroundColor: "#2196f3",
                color: "white",
                fontWeight: "bold",
                "&:hover": { backgroundColor: "#1976d2" },
              }}
            >
              Download
            </Button>
          </Grid>
        </Grid>

        <Grid item xs={12}>
          <Card>
            <MDTypography
              variant="h6"
              color="white"
              sx={{ backgroundColor: "#1976d2", p: 2, borderRadius: "4px" }}
            >
              CDR Report
            </MDTypography>

            {isLoading ? (
              <Box display="flex" justifyContent="center" alignItems="center" sx={{ py: 5 }}>
                <Loader />
              </Box>
            ) : rows.length === 0 ? (
              <MDTypography sx={{ p: 3, textAlign: "center", color: "gray" }}>
                No Record Found
              </MDTypography>
            ) : (
              <>
                <DataTable
                  table={{ columns, rows }}
                  isSorted={false}
                  entriesPerPage={false}
                  showTotalEntries={false}
                  noEndBorder
                  loading={isLoading}
                />
                {totalCount > rowsPerPage && (
                  <CustomPagination
                    count={totalCount}
                    page={page}
                    rowsPerPage={rowsPerPage}
                    onPageChange={(e, newPage) => setPage(newPage)}
                    onRowsPerPageChange={(e) => {
                      setRowsPerPage(parseInt(e.target.value, 100));
                      setPage(1);
                    }}
                  />
                )}
              </>
            )}
          </Card>
        </Grid>
      </Grid>
    </DashboardLayout>
  );
}

export default ReportTable;
